import { createSlice } from '@reduxjs/toolkit';
import { commonInitialState } from './common.initialState';

const commonSlice = createSlice({
  name: 'common',
  initialState: commonInitialState,
  reducers: {
    setIsProfileMenuOpen: (state, action) => {
      state.isProfileMenuOpen = action.payload;
    },
  },
  extraReducers: (builder) => {},
});

export const { setIsProfileMenuOpen } = commonSlice.actions;
export default commonSlice.reducer;
